var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-top":"1px solid #dfdfdf","margin-bottom":"30px"}},_vm._l((_vm.hotSchool),function(item,i){return _c('CollegeList',{key:i,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }